import {useEffect} from 'react'

import {useQuery} from '~/utils/helper'

export function Debug() {
  const {debug = ''} = useQuery()
  useEffect(() => {
    // 测试环境或debug=1时展示vconsole
    if (ENV !== 'production' || Number(debug) === 1) {
      import('vconsole').then((res) => {
        const Vconsole = res.default
        // eslint-disable-next-line no-new
        new Vconsole()
      })
    }
  }, [])
  return null
}
